import { render, staticRenderFns } from "./verified.vue?vue&type=template&id=35432fc3&scoped=true"
import script from "./verified.vue?vue&type=script&lang=js"
export * from "./verified.vue?vue&type=script&lang=js"
import style0 from "./verified.vue?vue&type=style&index=0&id=35432fc3&prod&lang=css"
import style1 from "./verified.vue?vue&type=style&index=1&id=35432fc3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35432fc3",
  null
  
)

export default component.exports